<template>
  <div class="tw-fixed tw-top-0 tw-bottom-0 tw-right-0 tw-left-0 tw-bg-gray-900 tw-bg-opacity-75 tw-flex tw-items-center tw-justify-center">
    <div class="tw-bg-white tw-p-5 tw-rounded-2xl">
      <div class="tw-flex tw-flex-col tw-items-center tw-max-w-[250px]">
      <img alt="money_icon" class="tw-h-20 tw-w-20 tw-object-contain" src="/icons/money.png" />
      <h2 class="tw-text-2xl tw-font-bold">Select Payment Plan</h2>
      <p>Select your ideal mode of payment for your motor insurance cover</p>
      </div>
      <div class="tw-flex tw-flex-col tw-items-stretch tw-gap-3 tw-mb-5">
        <div
            class="tw-flex tw-w-full tw-justify-between tw-bg-blue-100 tw-p-3 tw-rounded tw-font-medium tw-uppercase tw-text-xl text-primary tw-cursor-pointer"
            :class="plan.selected ? 'selected' : ''"
            v-for="plan in plans"
            :key="plan.value"
            @click="select(plan.value)"
        >
          <span>{{ plan.text }}</span>
          <span>{{ plan.value }}</span>
        </div>
      </div>
      <div class="tw-flex tw-justify-center">
        <v-btn color="primary" @click="proceedToPay">Proceed to Pay</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      plans: [
        {
          text: 'Full Premium',
          value: '100%',
          distribution: '100',
          selected: true,
        },
        {
          text: 'Instalments',
          value: '40%-60%',
          distribution: '40:60',
          selected: false,
        },
        {
          text: 'Instalments',
          value: '40%-30%-30%',
          distribution: '40:30:30',
          selected: false,
        },
      ],
    };
  },
  mounted() {
    const savedPlan = localStorage.getItem('selectedPaymentPlan');
    if (savedPlan) {
      this.select(savedPlan);
    }
  },
  methods: {
    select(value) {
      this.plans = this.plans.map((item) => (item.value === value ? { ...item, selected: true } : { ...item, selected: false }));
    },
    proceedToPay() {
      const selectedPlan = this.plans.find((plan) => plan.selected);
      localStorage.setItem('selectedPaymentPlan', selectedPlan.value);
      this.$emit('selected', selectedPlan.distribution);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.selected {
  border: 2px solid var(--blue-color);
}
.text-primary {
  color: var(--blue-color);
}
</style>
